(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("ActuatePumpProgramsController", ActuatePumpProgramsController);

  /** @ngInject */
  function ActuatePumpProgramsController($scope, $mdDialog, data) {
    var vm = this;

    init();

    vm.actuate = function () {
      $mdDialog.hide(data);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    function init() {
      data.forEach(function (item) {
        item.value = parseInt(item.value);
      });
      $scope.$on("$destroy", destroy);
      vm.data = data;
    }

    function destroy() {}
  }
})();
